export const SERVER = "https://api.v3.mjmarry.com/v3";
export const STREAM_API = "9frv7pruz8rj";